// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hydreigon: PokeData = {
  "id": 635,
  "name": "hydreigon",
  "height": 18,
  "weight": 1600,
  "base_experience": 270,
  "types": [
    PokeType.DARK,
    PokeType.DRAGON
  ],
  "api_moves": [
    "slam",
    "headbutt",
    "tackle",
    "body-slam",
    "bite",
    "roar",
    "hyper-beam",
    "dragon-rage",
    "focus-energy",
    "tri-attack",
    "scary-face",
    "outrage",
    "dragon-breath",
    "crunch",
    "hyper-voice",
    "assurance",
    "dragon-pulse",
    "dragon-rush",
    "nasty-plot",
    "double-hit",
    "work-up"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "body-slam",
    "bite",
    "tri-attack",
    "scary-face",
    "outrage",
    "dragon-breath",
    "crunch",
    "hyper-voice",
    "dragon-pulse",
    "dragon-rush",
    "night-daze"
  ],
  "evolution_chain": {
    "id": 323,
    "item": null,
    "species": [
      {
        "name": "deino",
        "order": 634,
        "types": [
          PokeType.DARK,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "zweilous",
        "order": 635,
        "types": [
          PokeType.DARK,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 633,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hydreigon",
        "order": 636,
        "types": [
          PokeType.DARK,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 634,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 64,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 125,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
